;(function () {
	window.addEventListener('load', () => {
		// Textarea auto height
		// const textareas = ['#hs-floating-textarea', '#hs-floating-textarea-gray', '#hs-floating-textarea-underline']
		const textareas = document.querySelectorAll('textarea')

		if (textareas.length === 0) {
			return
		}

		function textareaAutoHeight(el, offsetTop = 0) {
			el.style.height = 'auto'
			el.style.height = `${el.scrollHeight + offsetTop}px`
		}

		textareas.forEach(textarea => {
			textareaAutoHeight(textarea, 3)

			textarea.addEventListener('input', () => {
				textareaAutoHeight(textarea, 3)
			})
		})
	})
})()
